import React, { memo } from 'react'
import PatternFormat from 'transfix-ui/components/PatternFormat'
import uuid from 'uuid/v4'

interface IPhoneNumberProps {
  label?: string
  placeholder?: string
  value: string
  format?: string
  mask?: string
  id?: string
  dataTest?: string
  required?: boolean
  onChange?: () => void
}

export const PhoneNumber = memo<IPhoneNumberProps>(
  ({
    label,
    value,
    format = '(###) ###-####',
    placeholder = '(___) ___-____',
    mask = '_',
    id = uuid(),
    dataTest = 'phone-input',
    required = false,
    onChange,
  }) => (
    <>
      {label && (
        <label htmlFor={id} className={required ? 'required' : undefined}>
          {label}
        </label>
      )}
      <PatternFormat
        type='tel'
        placeholder={placeholder}
        value={value}
        format={format}
        mask={mask}
        id={id}
        data-test={dataTest}
        displayType='input'
        onChange={onChange}
      />
    </>
  )
)
